import { useEffect, useState } from 'react';
/**
 * Hook to add the m query param on an anchor href
 * to the original href when it is focused
 * @param href
 * @param mediumAttribute
 * @param elementRef
 * @returns {hrefWithMedium}
 */
export const useAddMediumQueryParam = (href, mediumAttribute, elementRef) => {
    const [hasBeenFocused, setHasBeenFocused] = useState(false);
    const handleOnFocus = () => {
        setHasBeenFocused(true);
    };
    useEffect(() => {
        const element = elementRef?.current;
        if (element) {
            element.addEventListener('mouseover', handleOnFocus);
            element.addEventListener('focus', handleOnFocus);
        }
        return () => {
            if (element) {
                element.removeEventListener('mouseover', handleOnFocus);
                element.removeEventListener('focus', handleOnFocus);
            }
        };
    }, [elementRef]);
    return {
        hrefWithMedium: mediumAttribute && hasBeenFocused && window?.isUser
            ? `${href}?m=${mediumAttribute}`
            : href,
    };
};
